// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"77be2d05","977":"5ca3318c"}[chunkId] + ".chunk.js";
};